<template>
  <div>
    <login-in-to-join-in :message="message" v-if="!loggedIn" :class="loginClass"></login-in-to-join-in>
    <add-display-name v-else-if="!completedLogin" :class="loginClass"></add-display-name>
    <slot v-else></slot>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import LoginInToJoinIn from "./LoginInToJoinIn";
import AddDisplayName from "./AddDisplayName";

export default {
  name: "IfCanTakePart",
  components: {AddDisplayName, LoginInToJoinIn},
  props: {
    message: {
      type: String,
      required: false,
      default: "Log in to Join in"
    },
    loginClass: {
      type: String,
      required: false,
      default: ""
    },
  },
  computed: {
    ...mapGetters(["loggedIn", "completedLogin"])
  }
};
</script>

<style scoped></style>
